import React, {Component} from "react";
import "./TagItem.css";
import CloseIcon from "../../../assets/close-icon-white.svg";
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

class TagItem extends Component {
    
    render(){
        const {
            label = "",
            onRemove,
            newColor
        } = this.props;

        return (
            <div 
                className='tag_item'
                style = {{
                    backgroundColor: newColor
                }}
            >
                <p>
                    {label}
                </p>
                <img src={CloseIcon} alt = "X" className="tag_close_icon" onClick={onRemove}/>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        uploadFolder: state.uploadFolder,
        newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    }
  }
  
const mapDispatchToProps = {
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TagItem))